import React, { createContext, useCallback, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';

export const SandboxProductionContext = createContext({ changeOrigin: () => {}, origenBack: '' });

function SandboxProductionProvider({ children }) {
  const [origenBack, setOrigenBack] = useState('');

  // console.log('origen del back', origenBack);

  const changeOrigin = (value) => {
    localStorage.setItem('originBack', value);
    window.location.reload();
  };

  useEffect(() => {
    const actualOrigin = localStorage.getItem('originBack');
    // console.log(actualOrigin);

    if (actualOrigin === 'sandbox') {
      setOrigenBack('sandbox');
    }
    if (actualOrigin === 'production') {
      setOrigenBack('production');
    }
    if (!actualOrigin) {
      setOrigenBack('');
    }
  }, []);
  return (
    <SandboxProductionContext.Provider value={{ changeOrigin, origenBack }}>
      {children}
    </SandboxProductionContext.Provider>
  );
}

export default SandboxProductionProvider;
